<template>
  <admin-wrapper :straight-title="additionalModuleName" :module-enabler="moduleEnabler" :has-buttons="false" />
</template>

<script>
import { get } from 'vuex-pathify';

import AdminWrapper from '@/components/AdminWrapper';

export default {
  name: 'VisibilityAnalysisSettings',
  components: {
    AdminWrapper,
  },
  computed: {
    additionalModuleName: get('admin/additionalModules@VIEWSHED.verbose_name'),
    moduleEnabler() {
      return {
        name: 'viewshed_area_module_enabled',
        straightText: this.additionalModuleName,
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', { suffix: this.additionalModuleName }),
      };
    },
  },
};
</script>
